/* eslint-disable no-continue */
/* eslint-disable no-plusplus */
import { loadTossPayments, ANONYMOUS, TossPaymentsWidgets } from "@tosspayments/tosspayments-sdk";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useForm, FormProvider } from "react-hook-form";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Section from "../../components/Section";
import {
  SectionProps,
  CardProps,
  initCards,
  InputTypes,
  removeLengthMinCardId,
  removeRequiredCardId,
  setLengthMinCardId,
  setRequiredCardId,
  StateProps,
  FormProps,
  ItemTypeProps,
} from "../../store";
import * as S from "./styles";
import PartnerLink from "../../components/PartnerLink";
import PageFooter from "../../components/PageFooter";
import axios from "axios";
import ProgramEnd from "../ProgramEnd";
import { API_URL } from "../../config";
import PageFooterBusiness from "../../components/PageFooterBusiness";
import "../../main.css";
import Spinner from "../../components/Spinner";
import { MAX_TOTAL_FILE_SIZE } from "../../components/InputFile";
import ChannelService from "../../components/ChannelTalk/channel-talk";
import ChannelTalkController from "../../components/ChannelTalk/channel-talk-controller";

interface ResultCardDataProps {
  formCardId: string;
  answer: string;
  formContentsId?: string;
  teamIndex?: number;
}

const Applicant = () => {
  const methods = useForm();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { cards } = useSelector((state: StateProps) => state);
  const { programIdOrCustomUrl } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isPreview = queryParams.get("isPreview");
  const [sections, setSections] = useState<SectionProps[]>([]);
  const [completeText, setCompleteText] = useState("");
  const [completeTitle, setCompleteTitle] = useState("");
  const [partnerLink, setPartnerLink] = useState("");
  const [partnerImage, setPartnerImage] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [programId, setProgramId] = useState("");
  const [programTitle, setProgramTitle] = useState("");
  const [programEnd, setProgramEnd] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // 추가된 부분
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [closedCardIds, setClosedCardIds] = useState<string[]>([]);
  const [clickSubmit, setClickSubmit] = useState<boolean>(false);
  const [accessKey, setAccessKey] = useState<string>("");
  const [loginEmail, setLoginEmail] = useState<string>("비로그인 사용자");

  const clientKey = "test_gck_docs_Ovk5rk1EwkEbP0W43n07xlzm";
  const customerKey = "ujLZcAlh3DLa-yhhjXfij";

  const [amount, setAmount] = useState({
    currency: "KRW",
    value: 1000,
  });
  const [ready, setReady] = useState(false);
  const [widgets, setWidgets] = useState<TossPaymentsWidgets | null>(null);
  const [isPayment, setIsPayment] = useState(false);
  const [agreeRefund, setAgreeRefund] = useState(false);

  useEffect(() => {
    if (programIdOrCustomUrl !== "tosstest") return;
    async function fetchPaymentWidgets() {
      // ------  결제위젯 초기화 ------
      const tossPayments = await loadTossPayments(clientKey);
      // 회원 결제
      // const widgets = tossPayments.widgets({
      //   customerKey,
      // });
      // 비회원 결제
      const widgets = tossPayments.widgets({ customerKey: ANONYMOUS });

      setWidgets(widgets);
    }

    fetchPaymentWidgets();
  }, [clientKey, customerKey]);

  // 컴포넌트 마운트 시 로컬스토리지에 저장된 데이터가 있으면 reset으로 채웁니다.
  // useEffect(() => {
  //   const savedFormData = localStorage.getItem("formData");
  //   if (savedFormData) {
  //     try {
  //       const parsedData: FormData = JSON.parse(savedFormData);
  //       methods.reset(parsedData);
  //     } catch (error) {
  //       console.error("저장된 폼 데이터를 파싱하는 데 문제가 발생했습니다:", error);
  //     }
  //   }
  // }, [methods]);

  useEffect(() => {
    if (programIdOrCustomUrl !== "tosstest") return;
    async function renderPaymentWidgets() {
      if (widgets == null) {
        return;
      }

      // ------ 주문의 결제 금액 설정 ------
      await widgets.setAmount(amount);

      await widgets.renderPaymentMethods({
        selector: "#payment-method",
        variantKey: "DEFAULT",
      });
      await widgets.renderAgreement({
        selector: "#agreement",
        variantKey: "AGREEMENT",
      });
      setReady(true);
    }

    renderPaymentWidgets();
  }, [widgets]);

  useEffect(() => {
    if (programIdOrCustomUrl !== "tosstest") return;
    if (widgets == null) {
      return;
    }

    widgets.setAmount(amount);
  }, [widgets, amount]);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const paymentKeyValue = urlParams.get("paymentKey");

    if (paymentKeyValue) {
      setIsPayment(true);
    }

    /* 파트너 페이지에서는 비회원 처리 */
    if (programIdOrCustomUrl === "hipartner") {
      // return console.log("hi partners!");
    }

    if (localStorage.getItem("accessKey") !== null) {
      setAccessKey(localStorage.getItem("accessKey")!);
    }

    // 메시지 수신
    const handleMessage = (event: MessageEvent) => {
      // 보낸 페이지의 origin 확인
      const { accessKey } = event.data;
      if (accessKey !== null && accessKey !== undefined) {
        setAccessKey(accessKey);
        localStorage.setItem("accessKey", accessKey);
      }
    };
    window.addEventListener("message", handleMessage);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  // access token 으로 /me 호출
  useEffect(() => {
    if (accessKey === "") return;

    axios
      .get(`${API_URL}/me`, {
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then((res) => {
        setLoginEmail(res.data.result.email);
        ChannelService.updateUser({
          profile: {
            email: res.data.result.email,
          },
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }, [accessKey]);

  const sendData = async () => {
    if (isPreview === "true") {
      alert("미리보기 페이지에서는 제출할 수 없습니다.");
      setIsSubmitting(false);
      return;
    }

    // ✅ 마감 체크 추가
    const isEnd = await checkIsEndBeforeSubmit();
    if (isEnd) {
      setIsSubmitting(false);
      return;
    }

    const originalCardsArr = [] as CardProps[];
    cards.forEach((item) => {
      if (item.inputType !== InputTypes.TITLE) {
        originalCardsArr.push(item);
      }
    });

    const resultCardsDataArr: ResultCardDataProps[] = [];

    for (let i = 0; i < originalCardsArr.length; i++) {
      if (
        originalCardsArr[i].inputType === InputTypes.TITLE ||
        originalCardsArr[i].inputType === InputTypes.FILE
      )
        continue;

      if (closedCardIds.includes(originalCardsArr[i].id)) continue;

      if (originalCardsArr[i].inputType === InputTypes.RADIO) {
        let formContentsId;

        if (methods.getValues()[originalCardsArr[i].id] === undefined) continue; // 값이 없으면 다음 카드로 넘어감

        const itemTypeProps = originalCardsArr[i].contents as ItemTypeProps[];

        for (let j = 0; j < itemTypeProps.length; j++) {
          if (itemTypeProps[j].text === methods.getValues()[originalCardsArr[i].id]) {
            formContentsId = itemTypeProps[j].id;
          }
        }

        if (formContentsId === undefined) {
          itemTypeProps.forEach((item) => {
            if (item.isEtc) {
              formContentsId = item.id;
            }
          });
        }

        resultCardsDataArr.push({
          formCardId: getFormCardId(originalCardsArr[i].id),
          answer: methods.getValues()[originalCardsArr[i].id],
          formContentsId: formContentsId
            ? formContentsId.replace("content-", "").split("-team-")[0]
            : undefined,
          teamIndex: getFormCardTeamIdx(originalCardsArr[i].id),
        } as ResultCardDataProps);
      } else if (originalCardsArr[i].inputType === InputTypes.CHECKBOX) {
        const answer = methods.getValues()[originalCardsArr[i].id];

        Object.keys(answer).forEach((key) => {
          if (answer[key]) {
            // 키를 "CHECKBOX X-Y" 형식에서 "CHECKBOX X"와 "Y"로 분리
            const [answer, formContentsId] = key.split("-1sep1-");
            const replacedAnswer = decodeURIComponent(escape(atob(answer)));
            resultCardsDataArr.push({
              formCardId: getFormCardId(originalCardsArr[i].id),
              answer: replacedAnswer,
              formContentsId: formContentsId.split("-team-")[0],
              teamIndex: getFormCardTeamIdx(originalCardsArr[i].id),
            } as ResultCardDataProps);
          }
        });
      } else if (originalCardsArr[i].inputType === InputTypes.SELECT) {
        const formContentsId = methods.getValues()[originalCardsArr[i].id];

        if (formContentsId === undefined) continue; // 값이 없으면 다음 카드로 넘어감

        const contents = originalCardsArr[i].contents as ItemTypeProps[];

        let answer;
        for (let j = 0; j < contents.length; j++) {
          if (contents[j].id === formContentsId) {
            answer = contents[j].text;
          }
        }

        resultCardsDataArr.push({
          formCardId: getFormCardId(originalCardsArr[i].id),
          answer,
          formContentsId: formContentsId.replace("content-", "").split("-team-")[0],
          teamIndex: getFormCardTeamIdx(originalCardsArr[i].id),
        } as ResultCardDataProps);
      } else {
        const resultCardData: ResultCardDataProps = {
          formCardId: getFormCardId(originalCardsArr[i].id),
          answer: methods.getValues()[originalCardsArr[i].id],
          teamIndex: getFormCardTeamIdx(originalCardsArr[i].id),
        };

        resultCardsDataArr.push(resultCardData);
      }
    }

    const files = [] as File[];
    const fileCardIds = [] as string[];
    let totalSize = 0; // 전체 파일 크기 저장 변수

    for (let i = 0; i < originalCardsArr.length; i++) {
      if (originalCardsArr[i].inputType === InputTypes.FILE) {
        const fileList = methods.getValues()[originalCardsArr[i].id];
        // console.log("원본 파일 목록:", fileList); // 원본 파일 목록 로그

        if (fileList === undefined) continue;

        for (let j = 0; j < fileList.length; j++) {
          const file = fileList[j];
          if (file === undefined) continue;
          if (file instanceof File) {
            files.push(file);
            totalSize += file.size;
            fileCardIds.push(getFormCardId(originalCardsArr[i].id));
            // console.log("추가된 파일:", file.name, "크기:", file.size, "총 크기:", totalSize); // 추가된 파일과 총 크기 로그
          }
        }
      }
    }

    // 30MB 초과 시 알림을 띄우고 에러 반환
    if (totalSize > MAX_TOTAL_FILE_SIZE) {
      const errorMessage = `전체 파일 용량이 ${(MAX_TOTAL_FILE_SIZE / 1024 / 1024).toFixed(
        2,
      )}MB를 초과했습니다. 총 파일 업로드 가능 용량은 ${(MAX_TOTAL_FILE_SIZE / 1024 / 1024).toFixed(
        2,
      )}MB입니다. 파일 수정 후 다시 업로드해주세요.\n현재 파일 총 용량: ${(
        totalSize /
        1024 /
        1024
      ).toFixed(2)}MB`;
      alert(errorMessage);
      setIsSubmitting(false);
      throw new Error(errorMessage); // 에러 반환
    }

    // FormData 생성
    const formData = new FormData();

    // 파일 추가
    files.forEach((file, index) => {
      formData.append("file", file);
      formData.append("fileCardId", fileCardIds[index]);
    });

    // console.log("업로드할 파일 목록:", files);

    // request 데이터 추가 (JSON으로 변환하여 추가)
    formData.append("request", JSON.stringify(resultCardsDataArr));

    try {
      const response = await axios.post(`${API_URL}/forms/${programId}/apply`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessKey}`,
        },
      });
      if (response.status === 406) {
        alert("답변 필수값을 확인해주세요.");
        throw new Error("Error: validation 에러");
      } else if (response.status === 401 || response.status === 402) {
        alert("로그인이 만료되었습니다. 다시 접속해주세요.");
        throw new Error("Error: 로그인 만료");
      } else if (response.status !== 200) {
        alert(response.data.message);
        throw new Error("Error: 서버 응답 에러");
      }
      navigate(`/form/complete/${programIdOrCustomUrl}`, {
        state: { completeText, completeTitle, partnerLink, partnerImage, partnerName },
      });
    } catch (error) {
      if (axios.isAxiosError(error)) {
        alert(error.response?.data?.message || error.message);
      } else {
        alert(error instanceof Error ? error.message : String(error));
      }
      throw new Error("Error: 서버 응답 에러");
    } finally {
      setIsSubmitting(false); // 제출 완료 후 버튼 다시 활성화
    }
  };

  const getFormCardId = (cardId: string) => cardId.split("-team-")[0];

  const getFormCardTeamIdx = (cardId: string) => {
    const teamIdx = cardId.split("-team-");

    if (teamIdx.length > 1) {
      return parseInt(teamIdx[1], 10);
    }
    return undefined;
  };

  const requestPayment = async () => {
    if (agreeRefund === false) {
      alert("환불 규정에 동의해주세요.");
      return;
    }
    const currentFormData = methods.getValues();
    localStorage.setItem("formData", JSON.stringify(currentFormData));
    try {
      await widgets?.requestPayment({
        orderId: "LJ9RYeEYfxrLtK15ZGCKM",
        orderName: "참가비",
        successUrl: `${window.location.href}`,
        failUrl: `${window.location.href}`,
        customerEmail: "customer123@gmail.com",
        customerName: "김토스",
        customerMobilePhone: "01012341234",
      });
    } catch (error) {
      alert(error);
    }
  };

  const checkIsEndBeforeSubmit = async (): Promise<boolean> => {
    try {
      const response = await axios.get(`${API_URL}/forms/${programIdOrCustomUrl}`);
      const { isEnd } = response.data as FormProps;

      if (isEnd) {
        alert("모집이 종료되었습니다.");
        return true;
      }

      return false;
    } catch (error) {
      console.error("마감 여부 확인 실패:", error);

      // ❗️실패해도 제출은 허용
      return false;
    }
  };

  const protectSnowflakeIds = (json: string): string => {
    const snowflakeKeys = ["programId"];

    const keyPattern = snowflakeKeys
      .map((key) => key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
      .join("|");

    const regex = new RegExp(`("(?:${keyPattern})"\\s*:\\s*)(-?\\d{16,20})(?=\\s*[,}\\]])`, "g");

    return json.replace(regex, (_match, prefix, value) => `${prefix}"${value}"`);
  };

  const parseJsonWithProtectedSnowflakeIds = <T,>(data: string): T =>
    JSON.parse(protectSnowflakeIds(data)) as T;

  const getSectionProps = async () => {
    let form = {} as FormProps;

    await axios
      .get(`${API_URL}/forms/${programIdOrCustomUrl}`, {
        responseType: "text",
        transformResponse: [(data) => data],
      })
      .then((res) => {
        if (res.status === 406) {
          alert("신청서가 존재하지 않습니다. url 을 확인하고 다시 시도해주세요.");
          navigate("/");
        } else if (res.status !== 200) {
          alert("신청서 정보를 불러오는데 실패했습니다. url 을 확인하고 다시 시도해주세요.");
          navigate("/");
        } else {
          // form = res.data as FormProps;
          form = parseJsonWithProtectedSnowflakeIds<FormProps>(res.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 406) {
          alert("신청서가 존재하지 않습니다. url 을 확인하고 다시 시도해주세요.");
          navigate("/");
        } else {
          alert("신청서 정보를 불러오는데 실패했습니다. url 을 확인하고 다시 시도해주세요.");
          navigate("/");
        }
      });

    setPartnerLink(form.partnerLink);
    setPartnerImage(form.partnerImage ?? "");
    setPartnerName(form.partnerName);
    setCompleteTitle(form.completeTitle);
    setCompleteText(form.completeText ?? "");
    setProgramId(form.programId.toString());
    setProgramTitle(form.programTitle);

    if (form.isEnd) {
      setProgramEnd(true);
    }

    const newSections: SectionProps[] = [];

    form.sections.forEach((section) => {
      const isAddable = section.teamNumber !== undefined && section.teamNumber > 1;

      const newCards: CardProps[] = [];

      if (isAddable) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        for (let i = 0; i < section.teamNumber!; i++) {
          section.cards.forEach((card) => {
            closedCardIds.push(`${card.id}-team-${i}`);

            if (card.inputType === InputTypes.CHECKBOX) {
              const contents = card.contents as ItemTypeProps[];
              const newContents = [] as ItemTypeProps[];
              for (let j = 0; j < contents.length; j++) {
                const idText = contents[j].text
                  ? btoa(unescape(encodeURIComponent(contents[j].text!)))
                  : "";
                const newId = `${idText}-1sep1-${contents[j].id}-team-${i}`;
                newContents.push({
                  id: newId,
                  text: contents[j].text,
                  isEtc: contents[j].isEtc,
                });
              }

              newCards.push({
                id: `${card.id}-team-${i}`,
                cardTitle: card.cardTitle,
                inputType: card.inputType,
                contents: newContents,
                subText: card.subText,
                placeholder: card.placeholder,
                isRequired: card.isRequired,
                lengthMin: card.lengthMin,
                isFocused: false,
              });
            } else if (
              card.inputType === InputTypes.RADIO ||
              card.inputType === InputTypes.SELECT
            ) {
              const contents = card.contents as ItemTypeProps[];
              const newContents = [] as ItemTypeProps[];
              for (let j = 0; j < contents.length; j++) {
                const newId = `content-${contents[j].id}-team-${i}`;
                newContents.push({
                  id: newId,
                  text: contents[j].text,
                  isEtc: contents[j].isEtc,
                });
              }

              newCards.push({
                id: `${card.id}-team-${i}`,
                cardTitle: card.cardTitle,
                inputType: card.inputType,
                contents: newContents,
                subText: card.subText,
                placeholder: card.placeholder,
                isRequired: card.isRequired,
                lengthMin: card.lengthMin,
                isFocused: false,
              });
            } else {
              newCards.push({
                id: `${card.id}-team-${i}`,
                cardTitle: card.cardTitle,
                inputType: card.inputType,
                contents: card.contents,
                subText: card.subText,
                placeholder: card.placeholder,
                isRequired: card.isRequired,
                lengthMin: card.lengthMin,
                isFocused: false,
              });
            }
          });
        }
      } else if (section && Array.isArray(section.cards)) {
        section.cards.forEach((card) => {
          if (card.inputType === InputTypes.CHECKBOX) {
            const contents = card.contents as ItemTypeProps[];
            const newContents = [] as ItemTypeProps[];
            for (let i = 0; i < contents.length; i++) {
              const idText = contents[i].text
                ? btoa(unescape(encodeURIComponent(contents[i].text!)))
                : "";
              const newId = `${idText}-1sep1-${contents[i].id}`;
              newContents.push({
                id: newId,
                text: contents[i].text,
                isEtc: contents[i].isEtc,
              });
            }

            newCards.push({
              id: card.id.toString(),
              cardTitle: card.cardTitle,
              inputType: card.inputType,
              contents: newContents,
              subText: card.subText,
              placeholder: card.placeholder,
              isRequired: card.isRequired,
              lengthMin: card.lengthMin,
              isFocused: false,
            });
          } else if (card.inputType === InputTypes.RADIO || card.inputType === InputTypes.SELECT) {
            const contents = card.contents as ItemTypeProps[];
            const newContents = [] as ItemTypeProps[];
            for (let i = 0; i < contents.length; i++) {
              const newId = `content-${contents[i].id}`;
              newContents.push({
                id: newId,
                text: contents[i].text,
                isEtc: contents[i].isEtc,
              });
            }

            newCards.push({
              id: card.id.toString(),
              cardTitle: card.cardTitle,
              inputType: card.inputType,
              contents: newContents,
              subText: card.subText,
              placeholder: card.placeholder,
              isRequired: card.isRequired,
              lengthMin: card.lengthMin,
              isFocused: false,
            });
          } else {
            newCards.push({
              id: card.id.toString(),
              cardTitle: card.cardTitle,
              inputType: card.inputType,
              contents: card.contents,
              subText: card.subText,
              placeholder: card.placeholder,
              isRequired: card.isRequired,
              lengthMin: card.lengthMin,
              isFocused: false,
            });
          }
        });
      } else {
        console.warn("카드가 없는 섹션이므로 건너뜁니다:", section);
        return;
      }
      newSections.push({
        formSectionId: section.formSectionId,
        sectionTitle: section.sectionTitle,
        isTitle: section.isTitle,
        cards: newCards,
        teamNumber: section.teamNumber,
      });
    });

    return newSections;
  };

  useEffect(() => {
    const cards = [] as CardProps[];

    getSectionProps().then((res) =>
      res.forEach((section) => {
        section.cards.forEach((card) => {
          cards.push(card);
        });
        dispatch(initCards(cards));
        setSections(res);
        setIsLoading(false);
      }),
    );
  }, []);

  const handleClick = () => {
    let errorCount = 0;
    let errorId = "";
    const CardIdArr = Object.keys(methods.getValues());
    for (let i = 0; i < CardIdArr.length; i++) {
      for (let j = 1; j < cards.length; j++) {
        if (closedCardIds.includes(cards[j].id)) continue;

        if (CardIdArr[i] === cards[j].id && cards[j].isRequired) {
          // j = 0 이면 타이틀 카드라서 뺌
          if (
            typeof cards[j].contents === "object" &&
            cards[j].inputType !== InputTypes.RADIO &&
            cards[j].inputType !== InputTypes.FILE &&
            cards[j].inputType !== InputTypes.SELECT
          ) {
            const isRequiredComplete = Object.values(methods.getValues()[cards[j].id]).some(
              (value) => !!value,
            );
            if (!isRequiredComplete) {
              dispatch(setRequiredCardId({ cardId: cards[j].id }));
              if (errorId === "") errorId = cards[j].id.toString();
              errorCount++;
            } else {
              dispatch(removeRequiredCardId({ cardId: cards[j].id }));
            }
          } else {
            const isRequiredComplete = !!methods.getValues()[cards[j].id];

            if (!isRequiredComplete) {
              dispatch(setRequiredCardId({ cardId: cards[j].id }));
              if (errorId === "") errorId = cards[j].id.toString();
              // eslint-disable-next-line no-plusplus
              errorCount++;
            } else {
              dispatch(removeRequiredCardId({ cardId: cards[j].id }));
            }
          }
        }
        if (
          CardIdArr[i] === cards[j].id &&
          cards[j].lengthMin !== undefined &&
          cards[j].isRequired
        ) {
          const length = cards[j].lengthMin ?? 0;

          if (methods.getValues()[cards[j].id] === undefined) continue;

          if (methods.getValues()[cards[j].id].length < length) {
            dispatch(setLengthMinCardId({ cardId: cards[j].id }));
            errorCount++;
            if (errorId === "") errorId = cards[j].id.toString();
          } else {
            dispatch(removeLengthMinCardId({ cardId: cards[j].id }));
          }
        }
      }
    }
    if (errorCount > 0) {
      const element = document.getElementById(errorId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" }); // 해당 태그 위치로 스크롤
      }
      alert("필수 항목을 입력해주세요");
      setClickSubmit(!clickSubmit);
      throw new Error("입력값 확인");
    }
  };

  if (programEnd && isPreview !== "true") {
    return (
      <ProgramEnd
        partnerLink={partnerLink}
        partnerImage={partnerImage}
        partnerName={partnerName}
        programTitle={programTitle}
      />
    );
  }
  return (
    <FormProvider {...methods}>
      <ChannelTalkController />
      <Helmet>
        <title>{sections[0]?.cards[0]?.cardTitle || "한달살러 폼"}</title>
        <meta name="title" content={programTitle} />
        <meta name="description" content="한달살러 폼으로 쉽고 빠르게 참여하세요." />
        <meta property="og:title" content={programTitle} />
        <meta property="og:description" content="한달살러 폼으로 쉽고 빠르게 참여하세요." />
      </Helmet>
      {isLoading ? (
        <span style={{ marginTop: "10px" }}> </span>
      ) : (
        <>
          <form
            onSubmit={methods.handleSubmit(() => {
              if (isSubmitting) return; // 이미 제출 중이라면 아무 동작도 하지 않음
              // 만약 결제폼이라면 결제 후 제출 가능하게 수정
              if (programIdOrCustomUrl === "tosstest" && !isPayment) {
                alert("결제 후 제출 가능합니다.");
                return;
              }
              setIsSubmitting(true); // 제출 중 상태로 설정
              try {
                handleClick();
                sendData();
              } catch (e) {
                console.dir(e);
                setIsSubmitting(false); // 오류 발생 시 제출 중 상태 해제
              }
            })}
          >
            <PartnerLink link={partnerLink} image={partnerImage} />
            {sections.map((section) => (
              <Section
                section={section}
                closedCardIds={closedCardIds}
                setClosedCardIds={setClosedCardIds}
                clickSubmit={clickSubmit}
                email={loginEmail}
              />
            ))}
            {programIdOrCustomUrl === "tosstest" && !isPayment && (
              <div>
                <S.TossSectionTitle>신청비 결제</S.TossSectionTitle>
                <S.PreviewSubmitTossSection>
                  <div className="w-full pt-2" id="payment-method" />
                  {/* 이용약관 UI */}
                  <div className="w-full" id="agreement" />
                  <div className="w-full flex flex-row">
                    <label className="text-[15px] text-[#515967] flex items-center pl-[30px] pb-4 cursor-pointer">
                      <input
                        type="checkbox"
                        className="mr-3 size-6 accent-lightGreen-500"
                        checked={agreeRefund}
                        onChange={(e) => setAgreeRefund(e.target.checked)}
                        required
                      />
                      [필수] 환불 규정을 확인했으며 이에 동의합니다
                    </label>
                    <button
                      type="button"
                      className="items-center h-6 underline text-[15px] text-[#515967] ml-3 cursor-pointer"
                      onClick={() =>
                        window.open("/form/refund", "RefundPolicy", "width=600,height=800")
                      }
                    >
                      [환불규정 자세히 보기]
                    </button>
                  </div>

                  <p className="text-sm text-center mt-5">
                    신청비는 1,000원입니다. 결제 후 제출하기가 완료됩니다.
                  </p>

                  <S.PayButton type="button" isDisabled={!ready} onClick={requestPayment}>
                    신청비 결제하기
                  </S.PayButton>
                </S.PreviewSubmitTossSection>
              </div>
            )}

            {isSubmitting && <Spinner />}

            {programIdOrCustomUrl === "tosstest" && isPayment && (
              <p className="text-sm text-center mt-5">
                결제가 완료됐습니다. 제출하기를 눌러서 완료해주세요.
              </p>
            )}
            <S.PreviewSubmitSection>
              <S.SubmitButton type="submit" isDisabled={isSubmitting} disabled={isSubmitting}>
                제출하기
              </S.SubmitButton>
            </S.PreviewSubmitSection>
          </form>

          {programIdOrCustomUrl === "tosstest" ? (
            <PageFooterBusiness partnerName={partnerName} />
          ) : (
            <PageFooter partnerName={partnerName} />
          )}
        </>
      )}
    </FormProvider>
  );
};

export default Applicant;
